import server from 'api/server';

const hasGarminOAuth = async () => await server.get('/hasGarminOAuth');

const oAuthGarmin = async userEmail => {
  const hasGarmin = await hasGarminOAuth();
  if (hasGarmin.data) {
    alert(`Your garmin account (${userEmail}) is already synced`);
    return;
  }
  window.location.replace(
    `${process.env.REACT_APP_SERVER_URL}/connect/garmin?state=${userEmail}`
  );
};

export default oAuthGarmin;
